import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["kindSelect", "cardCheck", "cardBrands"];

  connect() {
    if (this.hasKindSelectTarget) {
      this.kindSelectTarget.addEventListener("change", this.handleKindChange);
    }

    if (this.hasCardCheckTarget) {
      this.cardCheckTarget.addEventListener("change", this.handleCardCheckChange);
    }
  }

  disconnect() {
    if (this.hasKindSelectTarget) {
      this.kindSelectTarget.removeEventListener("change", this.handleKindChange);
    }

    if (this.hasCardCheckTarget) {
      this.cardCheckTarget.removeEventListener("change", this.handleCardCheckChange);
    }
  }

  handleKindChange = (event) => {
    let value = event.target.value;

    const formClass = `${value}-kind`;

    this.element.classList.remove("percentage-kind", "flat-kind");
    this.element.classList.add(formClass);
  };

  handleCardCheckChange = (event) => {
    console.log("CHANGE");
    if (event.target.checked) {
      this.cardBrandsTarget.classList.remove("hidden");
    } else {
      this.cardBrandsTarget.classList.add("hidden");
    }
  };
}
